<template>
  <div>
    <!-- 部分付款弹框 -->
    <el-dialog title="部分付款" :visible="buFenFKMark" :close-on-click-modal="false" width="600px" center @close="closeDialog">
      <div class="addressBox">
        <div style="width:80%;margin:0 auto;">
          <el-form :inline="true" :rules="rules" :model="buFenFKFrom" ref="buFenFKFrom" class="demo-form-inline" label-width="130px" size="small">
            <el-form-item label="待付金额:">
              <span style="color:red;font-size:18px;margin-right:5px;">{{buFenFKFrom.pendingAmount}}</span><span>元</span>
            </el-form-item>
            <el-form-item label="付款金额:" prop="collectionAmount">
              <el-input maxlength="10" v-model.trim="buFenFKFrom.collectionAmount" v-number-input.float="2" style="width:230px;"></el-input>
            </el-form-item>
            <el-form-item label="付款时间:" prop="collectionTime">
              <el-date-picker
                v-model="buFenFKFrom.collectionTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="付款凭证:" v-if="buFenFKMark" class="is-required">
              <uploadImgs :imgList.sync='imgList' style="margin-top:5px;" @remove='remove'></uploadImgs>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="buFenFKSubmitFn('buFenFKFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {waySomePaymentForYf } from '@/api/newTMS'
import uploadImgs from '@/components/uploadImgs.vue'
export default{
  components: {
    uploadImgs,
  },
  props: {
    buFenFKMark: {
      type: Boolean,
      default: false
    },
    buFenFKFrom: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imgList:[],
      rules:{
        collectionTime: [
          { required: true, message: '请选择收款时间', trigger: 'blur' }
        ],
        collectionAmount: [
          { required: true, message: '请输入收款金额', trigger: 'blur' }
        ],
      }
    }
  },
  mounted () {
    console.log(this.buFenFKFrom,'this.buFenFKFrom')
    this.$set(this.buFenFKFrom,'collectionTime','')
    this.$set(this.buFenFKFrom,'collectionAmount','')
  },
  methods: {
    // 删除图片
    remove (file) {
      console.log(file,'file')
    },
    closeDialog(){
      this.$emit('update:buFenFKMark', false)
      this.$refs.buFenFKFrom.resetFields()
    },
    buFenFKSubmitFn(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.imgList.length == 0 || this.imgList[0] == null) {
            this.$message({
              message: '收款凭证不能为空',
              type: 'error'
            })
            return
          }
          // 收款金额必须小于代收款金额
          if(this.buFenFKFrom.collectionAmount > this.buFenFKFrom.pendingAmount){
            this.$alert('收款金额必须小于待收款金额', '系统提示')
            return
          }
          let imgfile = new FormData()
          if(this.imgList.length > 0){
            imgfile.set('files', this.imgList[0].raw)
          }
          imgfile.set('params', JSON.stringify(this.buFenFKFrom))
          console.log(this.buFenFKFrom,'buFenFKFrom')
          this.waySomePaymentYf(imgfile)
        } else {
          return false
        }
      })
    },
    // 部分收款
    waySomePaymentYf(imgfile){
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      waySomePaymentForYf(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:buFenFKMark', false)
        this.$emit('refresh')
        this.$refs.buFenFKFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }
  }
}
</script>
<style scoped>

</style>